import React from 'react';

class MembersListItem extends React.Component{
  render(){
    return(
      <div className={'member-list-item-wrap ' + (this.props.className + "")}>
          <h4 className='bolder'><b>
          { this.props.link !== "" ?
              (<a className='member-link' href={this.props.link} target="_blank" rel="noopener noreferrer">{this.props.name} &raquo; </a>):(<span>{this.props.name} &raquo; </span>)
          }</b></h4>
          <p className='member-address'>{this.props.address}</p>
          <hr className='small-hr'/>
          {
              this.props.description !== "" ?
              (<p className='cb-p'>{this.props.description}</p>):("")
          }
         
      </div>
    );
  }
}

export default MembersListItem;